import range from 'lodash/range'

export const MIN_SUPPORTED_MATH_GRADE = 0

// Current maximum grade for which we have math standards
const MAX_SUPPORTED_MATH_GRADE = 9

// All grades for which we have math standards
export const SUPPORTED_MATH_GRADES = range(MIN_SUPPORTED_MATH_GRADE, MAX_SUPPORTED_MATH_GRADE + 1)

export const SUPPORTED_MATH_GRADES_WITH_SKILLSET = range(0, 9)

export const MIN_SUPPORTED_ELA_GRADE = 0
const MAX_SUPPORTED_ELA_GRADE = 12
export const SUPPORTED_ELA_GRADES = range(MIN_SUPPORTED_ELA_GRADE, MAX_SUPPORTED_ELA_GRADE + 1)

// Grades supported for School Assessments
export const MIN_SUPPORTED_ASSESSMENT_GRADE = 1
export const MAX_SUPPORTED_ASSESSMENT_GRADE = 8
